import { render, staticRenderFns } from "./ThemeCard.vue?vue&type=template&id=45cdbc37&scoped=true"
import script from "./ThemeCard.vue?vue&type=script&lang=js"
export * from "./ThemeCard.vue?vue&type=script&lang=js"
import style0 from "./ThemeCard.vue?vue&type=style&index=0&id=45cdbc37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cdbc37",
  null
  
)

export default component.exports